/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener("DOMContentLoaded", function(event) { 
$(".join_btn").click(function() {
  $('html,body').animate({
    scrollTop: $(".section-newsletter").offset().top},
                         'slow');
  });

$('.product-form__swatch__item--color').click(function() {
        var data_value = $(this).attr('data-value');
        $('.product-form__swatch__sub-title').text(data_value);
    });  
  
$('.product-form__swatch__label').click(function() {
        var data_value = $(this).attr('data-variant');
        var data_product = $(this).attr('data-productid');
        $(this).parents('.product-form__swatch').attr('data_index_value',data_value);
        var option_1 = $('.product-form__swatch[data-option-index="1"]').attr('data_index_value');
        var option_2 = $('.product-form__swatch[data-option-index="2"]').attr('data_index_value');
        var option_3 = $('.product-form__swatch[data-option-index="3"]').attr('data_index_value');
  		if (option_2 == null && option_3 == null){
          var selected = option_1 ;
        } else if (option_3 == null) {
          var selected = option_1 + '-' + option_2 ;
        } else {
          var selected = option_1 + '-' + option_2 + '-' + option_3;
        }
        $(".product-form__single-variant-select option[data-value='"+selected+"']").attr('selected', true).siblings().removeAttr('selected');
          
    });
    
  
  /*$('.p_swatch_1 .product-single__swatch__label').click(function(){
    var first_selected = $(this).text();
    var second_selected = $('.p_swatch_2 .product-single__swatch__item input[type=radio]:checked+label').text();
    var combination = first_selected + ' / ' + second_selected;
    $(".product-single__variant-select option:contains(" + combination + ")").attr('selected', true).siblings().removeAttr('selected');
  });
  $('.p_swatch_2 .product-single__swatch__label').click(function(){
    var first_selected = $('.p_swatch_1 .product-single__swatch__item input[type=radio]:checked+label').text();
    var second_selected = $(this).text();
    var combination = first_selected + ' / ' + second_selected;
    $(".product-single__variant-select option:contains(" + combination + ")").attr('selected', true).siblings().removeAttr('selected');
  });*/
  
  
  $('.meta_percentage,.vat_text').hide();
  function meta_variant(){
    var meta_price = $('.product-form__single-variant-select option:selected').attr('data-meta_price');
    var meta_compareprice =  $('.product-form__single-variant-select option:selected').attr('data-meta_compareprice');
    var meta_sku = $('.product-form__single-variant-select option:selected').attr('data-sku');
    var meta_shipping_msg = $('.product-form__single-variant-select option:selected').attr('data-shipping_msg');
    $('.pro_variant_sku').html(meta_sku);
    $('.stock_mess').html(meta_shipping_msg);
    
    if (meta_compareprice.length != '' && meta_price.length != ''){
      $('.js-product-price-number').hide();
      $('.meta_percentage,.vat_text').show();
      $('.meta_price').html('CHF '+ meta_price);
      $('.meta_compareprice del').html('CHF '+ meta_compareprice);
      var price = parseFloat(meta_price.replace(/[^\d.]/g, ''));  
      var compareprice = parseFloat(meta_compareprice.replace(/[^\d.]/g, ''));
      var diffv = price-compareprice;
      var diffpct = (diffv/compareprice)*100;
      var final_percent = diffpct.toFixed(0);
      $('.saved_meta_percent').html(final_percent+'%');
      $('span.meta_price,span.meta_compareprice,span.meta_percentage').show();
    } else {
      $('span.meta_price,span.meta_compareprice,span.meta_percentage').hide();
      $('.js-product-price-number').show();
    }
    var btn_text = $('button.product-form__add-btn .js-product-add-text').text();
    if (btn_text == 'Unavailable') {
      $('.ref__number, .product-single__price .price_percentage').css('opacity','0');
    } else {
      $('.ref__number, .product-single__price .price_percentage').css('opacity','1');
    }
  }
    setTimeout(function(){
    meta_variant();
  }, 300);
  $('.product-form__swatch__label').click(function(){
    setTimeout(function(){ 
    var unit_priceone = $('.single-option-selector option:selected').attr('unit_price');
    var meta_price = $('.single-option-selector option:selected').attr('data-meta_price');
    var meta_compareprice =  $('.single-option-selector option:selected').attr('data-meta_compareprice');
    var meta_sku = $('.single-option-selector option:selected').attr('data-sku');
    var meta_shipping_msg = $('.single-option-selector option:selected').attr('data-shipping_msg');
    $('.pro_variant_sku').html(meta_sku);
    $('.stock_mess').html(meta_shipping_msg);
 $('.unit__price').html(unit_priceone);
    if (meta_compareprice.length != '' && meta_price.length != ''){

      $('.meta_percentage,.vat_text').show();
      $('.meta_price').html('CHF '+ meta_price);
      $('.meta_compareprice del').html('CHF '+ meta_compareprice);
      var price = parseFloat(meta_price.replace(/[^\d.]/g, ''));  
      var compareprice = parseFloat(meta_compareprice.replace(/[^\d.]/g, ''));
      var diffv = price-compareprice;
      var diffpct = (diffv/compareprice)*100;
      var final_percent = diffpct.toFixed(0);
      $('.saved_meta_percent').html(final_percent+'% ');
      $('span.meta_price,span.meta_compareprice,span.meta_percentage').show();
    } else {
      $('span.meta_price,span.meta_compareprice,span.meta_percentage').hide();
        $('.money_custom .price__number .money').hide();
    }
    }, 200);
	
  });
});


// let text = document.getElementById("demo").innerHTML; 
// document.getElementById("demo").innerHTML = text.replace("Sauvegarder", "-");

 // $('.custom_localize.localize').click(function(){
 //   $(this).toggleClass('custom_visibal');
 // });



